import { Action } from '@ngrx/store';
import * as Actions from './formio-e-signature.actions';
import { IFormioESignatureState } from './formio-e-signature.model';

export const formioESignatureState: IFormioESignatureState = {
  createFormioSignLoading: false,
  createFormioSignLoaded: false,
  deleteFormioSignLoading: false,
  deleteFormioSignLoaded: false,
};

export function formioESignatureReducer(
  state: IFormioESignatureState = formioESignatureState,
  baseAction: Action,
): IFormioESignatureState {
  const action: Actions.FormioESignatureActions = baseAction as Actions.FormioESignatureActions;
  switch (action.type) {
    case Actions.CREATE_FORMIO_E_SIGN:
      return {
        ...state,
        createFormioSignLoading: true,
        createFormioSignLoaded: false,
      };
    case Actions.CREATE_FORMIO_E_SIGN_COMPLETED:
      return {
        ...state,
        createFormioSignLoading: false,
        createFormioSignLoaded: true,
      };
    case Actions.DELETE_FORMIO_E_SIGN:
      return {
        ...state,
        deleteFormioSignLoading: true,
        deleteFormioSignLoaded: false,
      };
    case Actions.DELETE_FORMIO_E_SIGN_COMPLETED:
      return {
        ...state,
        deleteFormioSignLoading: false,
        deleteFormioSignLoaded: true,
      };
    default:
      return state;
  }
}
